import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { debounceTime, filter } from 'rxjs/operators';
import { isUndefined, forEach } from 'lodash';

@Component({
  selector: 'eyrus-questionnaire-question-text',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuestionTextComponent), multi: true
    }
  ]
})
export class QuestionTextComponent implements OnInit {

  @Input() readOnly: Boolean = false;
  @Input() isNumber: Boolean = false;

  questionControl: FormControl = new FormControl();
  private subscriptions: any = {};

  propagateChange: any = () => { };
  propageteTouch: any = () => { };
  validateFn: any = () => { };

  constructor() { }

  ngOnInit() {
    this.watchChanges();
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (value) => value.unsubscribe());
  }

  //  functions to be used inside a reactive form
  writeValue(value) {
    this.questionControl.setValue(value);
  }

  //  functions to be used inside a reactive form
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  //  functions to be used inside a reactive form
  registerOnTouched(fn) {
    this.propageteTouch = fn;
  }

  /**
   * Watch value changes for input text
   */
  private watchChanges() {
    this.subscriptions.text = this.questionControl.valueChanges
      .pipe(
        debounceTime(300),
        filter(text => !isUndefined(text))
      )
      .subscribe(val => {
        this.propagateChange(val);
        this.propageteTouch(val);
      });
  }

}
